import React from 'react';
import { SunriseIcon, SunsetIcon } from 'lucide-react';
import { fees, stayTimes } from '../../data/units';
import { formatNaira } from '../../utils/format';
interface StayOptionsProps {
  earlyCheckIn: boolean;
  lateCheckout: boolean;
  onToggleEarly: () => void;
  onToggleLate: () => void;
}
const range = `${formatNaira(fees.earlyLateMin)}–${formatNaira(fees.earlyLateMax)}`;
export function StayOptions({
  earlyCheckIn,
  lateCheckout,
  onToggleEarly,
  onToggleLate
}: StayOptionsProps) {
  const options = [{
    id: 'early',
    label: 'Request early check-in',
    detail: `Arrive before ${stayTimes.checkIn}`,
    checked: earlyCheckIn,
    onToggle: onToggleEarly,
    icon: SunriseIcon
  }, {
    id: 'late',
    label: 'Request late checkout',
    detail: `Leave after ${stayTimes.checkOut}`,
    checked: lateCheckout,
    onToggle: onToggleLate,
    icon: SunsetIcon
  }];
  return <fieldset data-id="element-191" data-mp="1ad5jm7ezwrav">
      <legend className="text-[11px] uppercase tracking-overline text-gold-700" data-id="element-192" data-mp="1acvq49uqs20f">Optional requests</legend>
      <div className="mt-4 grid gap-3 sm:grid-cols-2" data-id="element-193" data-mp="3sfy60cnnvc7r">
        {options.map(option => <label key={option.id} className={`flex cursor-pointer items-start gap-3 rounded-sm p-4 transition-colors duration-150 ease-premium ${option.checked ? 'bg-gold-100 ring-1 ring-gold-400' : 'bg-ivory-50 ring-1 ring-forest-700/10 hover:bg-ivory-200'}`} data-id="element-194" data-mp="3nl20c9pi4qc6">
            <input type="checkbox" checked={option.checked} onChange={option.onToggle} className="mt-1 h-4 w-4 shrink-0 accent-forest-700" data-id="element-195" data-mp="a88n4ak7nogo" />
            <span className="flex-1" data-id="element-196" data-mp="17tzv5norzaj">
              <span className="flex items-center gap-2 text-[14px] text-ink" data-id="element-197" data-mp="16seo8cyhwf3">
                <option.icon size={15} className="text-gold-500" aria-hidden="true" data-id="element-198" data-mp="2qx5qroshevag" />
                {option.label}
              </span>
              <span className="mt-1 block text-[12px] text-muted" data-id="element-199" data-mp="2lwht4k9qzg79">{option.detail}</span>
              <span className="mt-1 block text-[12px] text-gold-700" data-id="element-200" data-mp="2nfhspcgv32th">{range} · charged only if approved</span>
            </span>
          </label>)}
      </div>
    </fieldset>;
}